"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileNav = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = require("react");
const content_1 = require("../../content");
const datatypes_1 = require("../../datatypes");
const Menu_1 = require("./Menu");
const MenuTrigger_1 = require("./MenuTrigger");
const MobileNav_module_css_1 = __importDefault(require("./MobileNav.module.css"));
const react_intl_1 = require("react-intl");
const LocalizationWrapper_1 = require("../LocalizationWrapper");
const web_search_bar_1 = require("@snapchat/web-search-bar");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const useSearchQuery_1 = __importDefault(require("../../hooks/useSearchQuery"));
/**
 * Public Nav component for mobile
 */
function MobileNav(props) {
    const [isMenuOpen, setIsMenuOpen] = (0, react_1.useState)(false);
    const menuWrapperClass = (0, clsx_1.default)(MobileNav_module_css_1.default.menuContainer, { [MobileNav_module_css_1.default.menuContainerActive]: isMenuOpen });
    const intl = (0, react_intl_1.useIntl)();
    const pageType = props.pageType || web_blizzard_reporting_1.PageType.UNSET;
    const requiredProps = {
        onItemClick: props.onItemClick || (() => null),
        onGroupToggle: props.onGroupToggle || (() => null),
        items: props.items || (0, content_1.getMobileNavigationItems)(intl),
        downloadLink: props.downloadLink || content_1.DOWNLOAD_LINK,
        localeChange: props.localeChange || (() => null),
        locale: props.locale,
        pageType,
        messages: props.messages || {},
        hideSearchBar: props.hideSearchBar || false,
    };
    const onItemClick = requiredProps.onItemClick;
    const handleMenuClick = (0, react_1.useCallback)((event) => {
        setIsMenuOpen(true);
        onItemClick(event, datatypes_1.MobileNavItemType.SUB_MENU);
    }, [onItemClick]);
    const searchQuery = (0, useSearchQuery_1.default)(pageType);
    return ((0, jsx_runtime_1.jsxs)("div", { className: MobileNav_module_css_1.default.root, children: [(0, jsx_runtime_1.jsx)(MenuTrigger_1.MenuTrigger, { onMenuClick: handleMenuClick }), (0, jsx_runtime_1.jsx)("div", { "data-testid": "mobile-nav-menu-wrapper", className: menuWrapperClass, children: (0, jsx_runtime_1.jsx)(Menu_1.Menu, { onMenuClose: () => setIsMenuOpen(false), items: requiredProps.items, downloadLink: requiredProps.downloadLink, onItemClick: requiredProps.onItemClick, onGroupToggle: requiredProps.onGroupToggle, isOpen: isMenuOpen, locale: requiredProps.locale, localeChange: requiredProps.localeChange }) }), !props.hideSearchBar && ((0, jsx_runtime_1.jsx)("div", { "data-testid": "Search_Bar", className: MobileNav_module_css_1.default.searchBar, children: (0, jsx_runtime_1.jsx)(web_search_bar_1.SearchBar, { pageType: requiredProps.pageType, expandOnFocus: true, localeProps: requiredProps.locale, messagesProps: requiredProps.messages, searchQuery: searchQuery }) }))] }));
}
/**
 * Localization Wrapper for Mobile Navigation component
 */
function MobileNavWrapper(props) {
    const { locale, messages } = props;
    return ((0, jsx_runtime_1.jsx)(LocalizationWrapper_1.LocalizationWrapper, { locale: locale, messages: messages, children: (0, jsx_runtime_1.jsx)(MobileNav, { ...props }) }));
}
exports.MobileNav = MobileNavWrapper;
//# sourceMappingURL=MobileNav.js.map